import { render, staticRenderFns } from "./SettlementsComponent.vue?vue&type=template&id=374caebc&scoped=true&"
import script from "./SettlementsComponent.vue?vue&type=script&lang=js&"
export * from "./SettlementsComponent.vue?vue&type=script&lang=js&"
import style0 from "./SettlementsComponent.vue?vue&type=style&index=0&id=374caebc&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374caebc",
  null
  
)

export default component.exports